import { Toast } from "primereact/toast";
import { createContext, useContext } from "react";

export const ToastContext = createContext(null);

export function ToastWithRef() {
  const ref = useContext(ToastContext);
  return <Toast ref={ref} position="top-center" />;
}
